"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetWorkspaceSettingsLoader = exports.getWorkspaceSettingsLoader = void 0;
var util_1 = require("@gooddata/util");
var LOADER_CACHE_SIZE = 20;
var WorkspaceSettingsLoader = /** @class */ (function () {
    function WorkspaceSettingsLoader() {
        this.settingsCache = new util_1.LRUCache({ maxSize: LOADER_CACHE_SIZE });
    }
    WorkspaceSettingsLoader.prototype.load = function (backend, workspace) {
        var _this = this;
        var cacheKey = workspace;
        var settings = this.settingsCache.get(cacheKey);
        if (!settings) {
            settings = backend
                .workspace(workspace)
                .settings()
                .getSettingsForCurrentUser()
                .catch(function (error) {
                // do not cache errors
                _this.settingsCache.delete(cacheKey);
                throw error;
            });
            this.settingsCache.set(cacheKey, settings);
        }
        return settings;
    };
    return WorkspaceSettingsLoader;
}());
var workspaceSettingsLoaderInstance;
/**
 * Gets a loader object for loading workspace settings data efficiently.
 */
function getWorkspaceSettingsLoader() {
    if (!workspaceSettingsLoaderInstance) {
        workspaceSettingsLoaderInstance = new WorkspaceSettingsLoader();
    }
    return workspaceSettingsLoaderInstance;
}
exports.getWorkspaceSettingsLoader = getWorkspaceSettingsLoader;
/**
 * Resets the cached loader object for loading workspace settings data efficiently.
 */
function resetWorkspaceSettingsLoader() {
    workspaceSettingsLoaderInstance = undefined;
}
exports.resetWorkspaceSettingsLoader = resetWorkspaceSettingsLoader;
//# sourceMappingURL=workspaceSettingsLoader.js.map